export enum StepPage {
    MAIN = 0,
    CHOOSE_TOPIC = 1,
    SUMMARY = 2,
    SEND_INTEREST = 3,
    THANKYOU = 4
}